// ============================================================================
// Aura de l'avatar sur la page d'une SKILLCARD — PUR, testé.
// ============================================================================
// Niveau global = maîtrise × part des HORA gagnés (0..100). Il donne un palier
// 0..11 : chaque palier AJOUTE un effet animé autour de l'avatar.
//   0 → aucun effet ; ]0..10] → 1 ; ]10..20] → 2 ; … ; ]90..100[ → 10 ;
//   100 (maîtrise totale ET HORA max) → 11.
// ============================================================================

/** Nombre total d'effets d'aura (palier maximum). */
export const AURA_TIER_COUNT = 11;

/** Niveau global 0..100 = (maîtrise / 100) × (HORA / HORA max) × 100. */
export function cardAuraScore(mastery: number, xp: number, xpMax: number): number {
  if (!Number.isFinite(mastery) || !Number.isFinite(xp) || !Number.isFinite(xpMax)) return 0;
  if (xpMax <= 0) return 0;
  const m = Math.min(100, Math.max(0, mastery)) / 100;
  const h = Math.min(1, Math.max(0, xp / xpMax));
  return m * h * 100;
}

/** Palier 0..11 d'un niveau global 0..100. */
export function cardAuraTier(score: number): number {
  if (!Number.isFinite(score) || score <= 0) return 0;
  if (score >= 100) return AURA_TIER_COUNT;
  return Math.min(AURA_TIER_COUNT - 1, Math.ceil(score / 10));
}

// ---------------------------------------------------------------------------
// Statut de maîtrise affiché à côté du pourcentage (« À consolider »…).
// Le seuil « Maîtrisée » = 80, miroir de SKILLCARD_MASTERED_THRESHOLD (app).
// ---------------------------------------------------------------------------

export type CardMasteryStatus = 'discover' | 'work' | 'consolidate' | 'mastered';

export const CARD_MASTERY_STATUS_LABELS: Record<CardMasteryStatus, string> = {
  discover: 'À découvrir',
  work: 'À travailler',
  consolidate: 'À consolider',
  mastered: 'Maîtrisée',
};

/** Statut d'après la maîtrise (0..100) ; `used=false` = jamais travaillée. */
export function cardMasteryStatus(mastery: number, used: boolean): CardMasteryStatus {
  if (!used) return 'discover';
  const m = Number.isFinite(mastery) ? mastery : 0;
  if (m >= 80) return 'mastered';
  if (m >= 40) return 'consolidate';
  return 'work';
}

/** HORA restant avant le max (jamais négatif). */
export function horaRemaining(xp: number, xpMax: number): number {
  if (!Number.isFinite(xp) || !Number.isFinite(xpMax)) return 0;
  return Math.max(0, Math.round(xpMax - xp));
}
